export default {
    title: "AELU",
    ssv: "विशिष्ट कौशल वीजा",
    what_ssv: "विशिष्ट कौशल वीजा",
    representative_message: "प्रतिनिधि संदेश",
    aeru_feature: "AELU की विशेषताएं",
    aeru_how_to_use: "उपयोग का प्रवाह",
    aeru_q_a: "क्यू एंड ए",
    aeru_function: "AELU के कार्य",
    aeru_fee: "AELU के आरोप",
    login: "लॉग इन करें",
    db_top_comment1: "उद्योग में पहले! विशिष्ट कौशल वीज़ा परीक्षा के लिए स्मार्टफोन ऑनलाइन प्रशिक्षण साइट।",
    db_top_comment2: "AELU एक वेब सेवा है जो परीक्षा, परीक्षा की जानकारी और आवेदन एजेंसी के लिए अध्ययन करके विशिष्ट कौशल वीजा के अधिग्रहण का समर्थन करती है।",
    db_top_pr: "नए अवसरों को जब्त करने के लिए अपने विशिष्ट कौशल वीज़ा का उपयोग करें।",
    member_regist: "सदस्य पंजीकरण",
    registration_support_organization: "पंजीकरण सहायता संगठन क्या है?",
    rso_dec1: "विशिष्ट कौशल प्रणाली में दो संगठन हैं, विशिष्ट कौशल संबद्ध संगठन और पंजीकरण सहायता संगठन। एक विशिष्ट कौशल संबद्धता संगठन एक कंपनी (स्वीकार करने वाला संगठन) है जो विशिष्ट कौशल के साथ विदेशियों को रोजगार देता है। जिस संस्थान के पास विशिष्ट कौशल है, उसे कार्यस्थल, दैनिक जीवन और समाज में विशिष्ट कौशल के साथ विदेशियों के लिए समर्थन प्रदान करना चाहिए।",
    rso_dec2: "चूंकि विशिष्ट कौशल वाले विदेशियों का समर्थन करने में विशेष सामग्री होती है, इसलिए ऐसे मामले हैं जहां कंपनी के लिए यह मुश्किल है कि वे विशिष्ट कौशल के साथ विदेशियों को रोजगार दें, संस्था जिसमें विशिष्ट कौशल हैं, समर्थन प्रदान करने के लिए। एक पंजीकरण सहायता संगठन एक संगठन है जिसे विशिष्ट कौशल के साथ विदेशियों के लिए एक समर्थन योजना बनाने और लागू करने के लिए एक विशिष्ट कौशल संबद्ध संगठन को सौंपा जाता है।",
    rso_dec3: "एक पंजीकरण सहायता संगठन एक संगठन है जिसे विशिष्ट कौशल के साथ विदेशियों के लिए एक समर्थन योजना बनाने और लागू करने के लिए एक विशिष्ट कौशल संबद्ध संगठन को सौंपा जाता है।",
    rso_dec4: "पंजीकरण सहायता संगठन मेजबान संगठन के साथ एक समर्थन खेप अनुबंध के माध्यम से नंबर 1 निर्दिष्ट कुशल विदेशी सहायता योजना के आधार पर सभी सहायता प्रदान करेगा।",
    rso_dec5: "Organization पंजीकरण सहायता संगठन बनने के लिए, आपको जापान के आव्रजन ब्यूरो के आयुक्त द्वारा पंजीकृत होना चाहिए।",
    rso_dec6: "Organization पंजीकृत संस्थानों को पंजीकरण सहायता संगठन रजिस्टर में पंजीकृत किया जाएगा और जापान की आव्रजन ब्यूरो वेबसाइट पर पोस्ट किया जाएगा।",
    rso_dec7: "Renew पंजीकरण की अवधि 5 वर्ष है और इसे नवीनीकृत करने की आवश्यकता है।",
    rso_dec8: "To पंजीकरण सहायता संगठनों को किसी भी समय जापान के आव्रजन ब्यूरो को विभिन्न सूचनाएं जमा करने की आवश्यकता होती है।",
    article1: "विशिष्ट कौशल वीजा क्या है?",
    article1_dec1: "8 दिसंबर, 2018 को संशोधित आव्रजन नियंत्रण अधिनियम के लागू होने के साथ, निवास विशिष्ट कौशल की स्थिति नव स्थापित हो गई थी। अप्रैल 2019 में लागू किया गया।",
    article1_dec2: "निवास की एक नई स्थिति विशिष्ट कौशल दो चरणों में स्थापित की जाएगी। (नंबर 1 और नंबर 2)",
    article1_dec3: "लक्ष्य उद्योग 14 उद्योग हैं।",
    article1_dec4: "लक्ष्य विदेशियों की आवश्यकता एक ऐसा व्यक्ति है जिसके पास कौशल है जिसमें काफी ज्ञान या अनुभव की आवश्यकता होती है। दूसरे शब्दों में, जिन लोगों ने तकनीकी इंटर्न ट्रेनिंग के तीन साल पूरे कर लिए हैं या जो समकक्ष जापानी भाषा और दक्षता परीक्षा पास कर चुके हैं, वे पात्र हैं।",
    article1_dec5: "विशिष्ट कौशल नंबर 1 को कुछ कौशल वाले व्यक्ति के रूप में 5 साल तक रहने की अनुमति है। परिवार के सदस्यों को अनुमति नहीं है।",
    article1_dec6: "कुशल कौशल वाले व्यक्ति के रूप में, विशिष्ट कौशल संख्या 2 को विशिष्ट कौशल संख्या 1. \n की अवधि के दौरान एक विशेष परीक्षा उत्तीर्ण करके सामान्य रोजगार के बराबर निवास का दर्जा दिया जाता है (रहने की अवधि को नवीनीकृत करके, आप रह सकते हैं स्थायी रूप से, और आप अपने परिवार को अपने साथ ला सकते हैं।);",
    article2: "प्रतिनिधि संदेश",
    article2_sub1: "अभी तक जापान को नहीं छोड़ा",
    article2_dec1: "हम कई तकनीकी प्रशिक्षुओं और तकनीकी प्रशिक्षुओं के रूप में जापान में आए प्रशिक्षुओं और तकनीकी प्रशिक्षण प्राप्त प्रशिक्षुओं के प्रति अपनी ईमानदारी का आभार व्यक्त करना चाहते हैं और अपने देश के विकास के लिए कोई प्रयास नहीं किया है। मुझे लगता है कि परिवार की खातिर और स्वदेश के लिए, जो आज जापान में नहीं है, के अभ्यास की उपस्थिति मूल मानव उपस्थिति है। जबकि मैं लंबे समय से तकनीकी प्रशिक्षु प्रशिक्षण व्यवसाय में शामिल हूं, केवल तकनीकी प्रशिक्षु वीजा के साथ देश में प्रवेश करने का कोई तरीका नहीं है, और मैं उस अवसर का लाभ उठाता हूं, जापान में दृढ़ता से अभ्यास करता हूं, अपने व्यवसाय को खोलता हूं मेरा देश, और मेरा देश बहुत विकसित हो रहा है मैंने बहुत कुछ देखा। हालांकि, अप्रैल 2019 में, एक वीजा विशिष्ट कौशल वीजा का निर्माण किया गया था, जो जापान का आनंद लेने की इच्छा को पूरा करता है, जिसे निर्धारित वर्षों में पूरी तरह से सीखा नहीं जा सकता है। मुझे उम्मीद है कि जापान जाने वाले कई विदेशी जिनकी आंखों के पीछे महत्वाकांक्षाएं हैं, जो जापान में दुर्लभ हैं, वे जापान को एक साथ विकसित कर सकते हैं। इन सबसे ऊपर, मैं जापान जैसे लोगों को रखना चाहता हूं, स्थायी निवासियों की संख्या बढ़ाता हूं, और एक ऐसा समाज बनाता हूं जहां वे एक साथ रह सकें।",
    article2_dec2: "विज़ुअलाइज़ेशन कं, लिमिटेड",
    article2_dec3: "राष्ट्रपति और सीईओ",
    article2_dec4: "काज़ुहिको होरिउची",
    article3: "AELU द्वारा प्रदान की गई तीन विशेषताएं",
    article3_sub1: "ऑनलाइन परीक्षा के लिए अध्ययन",
    article3_sub1_dec1: "AELU, जो आपको अपने स्मार्टफोन पर विशिष्ट कौशल परीक्षण के लिए तैयार करने की अनुमति देता है, सभी 14 उद्योगों में 30 प्रश्नों के बाद छद्म प्रश्न तैयार करता है, जिसमें पिछले प्रश्न भी शामिल हैं, और आप परीक्षा की तारीख के अनुसार जितनी बार चाहें उतनी बार उपाय कर सकते हैं। यदि आप AI द्वारा पूछे जाने वाले प्रश्नों के लिए निर्दिष्ट स्कोर को पार कर लेते हैं, तो आप निश्चित रूप से परीक्षा पास कर लेंगे!",
    article3_sub2: "परीक्षा की जानकारी",
    article3_sub2_dec1: "जापान के लिए विदेशी आगंतुकों के लिए परीक्षण की जानकारी जो बहुत कठिन है, स्वतः ही जोड़ दी जाएगी जब पंजीकरण के बाद चयनित उद्योग की परीक्षण जानकारी अपडेट की जाती है, और उपयोगकर्ता को सूचित किया जाएगा।",
    article3_sub3: "परीक्षा आवेदन एजेंसी",
    article3_sub3_dec1: "परीक्षा की जानकारी के साथ, जापान में विदेशी आगंतुकों के लिए परीक्षा के लिए आवेदन करना बहुत मुश्किल है, और आप ऑनलाइन प्रक्रिया पूरी किए बिना भी परीक्षा नहीं दे सकते। जब आप पंजीकरण करते हैं, तो आप जानकारी पोस्ट कर सकते हैं, पहले से ही आवेदन फॉर्म है, और परीक्षण की घोषणा के समान ही आवेदन करें।",
    article4: "टेस्ट पास करने के बाद फंक्शन इंट्रोडक्शन",
    article4_sub1: "सफल आवेदकों को बधाई \n कैश बैक (घरेलू या अंतर्राष्ट्रीय)",
    article4_sub1_dec1: "यदि आप पहले से ही जापान में रहते हैं और AELU का उपयोग करके पास करते हैं और अपनी उपयोगकर्ता स्क्रीन पर पास नंबर और पास प्रमाणपत्र अपलोड करते हैं, तो आप उसी दिन नकद वापस पा सकते हैं। कैश बैक प्लान उत्पाद: ऑनलाइन गिफ्ट सर्टिफिकेट (अमेजन गिफ्ट सर्टिफिकेट ईमेल) टाइप, गूगलप्ले, आईट्यून्स गिफ्ट कार्ड) LINE आधिकारिक खाते से 5000 येन का कैश बैक।",
    article4_sub2: "एक मित्र अभियान देखें",
    article4_sub2_dec1: "आवेदकों को जापान के लिए आमंत्रित करें जो जापान या विदेश में हैं एफबी समूह में शामिल होने के लिए, उपयोगकर्ता खुद को प्रबंधन संख्या बताएगा और उस नंबर से जुड़े व्यक्ति को नकद वापस करेगा, और 1000 ऑनलाइन उपहार प्रमाण पत्र परिचयकर्ता को दिए जाएंगे जुड़ने के बाद का महीना। येन कैश बैक।",
    article4_sub3: "वीजा मिलने के बाद, नौकरी की तलाश \n AI स्वचालित मिलान (अनिर्णीत) है",
    article4_sub3_dec1: "AELU का उपयोग करके प्रमाणन परीक्षा उत्तीर्ण करने के बाद, उपयोगकर्ता स्क्रीन पर पास नंबर और पास प्रमाणपत्र अपलोड करें, और आपको जापान में सभी कंपनियों से स्वचालित प्रस्ताव प्राप्त होंगे। साक्षात्कार भी ऑनलाइन आयोजित किए जाएंगे, और आप प्रारंभिक अनौपचारिक अध्याय में भी ऑनलाइन कनेक्ट करके देश में प्रवेश कर सकते हैं, स्थानांतरित कर सकते हैं और मन की शांति के साथ नौकरी पा सकते हैं!",
    article4_sub4: "निवास कार्ड \n कैश बैक (अनिर्धारित) की नियमित जाँच",
    article4_sub4_dec1: "यदि आप अपने निवास कार्ड को महीने में एक बार बिना किसी निवास स्थान के चेक कार्ड वन एप्लिकेशन टैब में चेक करते हैं, तो आपको एक वर्ष में 10,000 येन नकद मिलेंगे",
    article5: "विशिष्ट कार्य परिचय",
    article5_sub1: "आप हल की गई समस्या पर वापस देख सकते हैं",
    article5_sub1_dec1: "आप उन परीक्षा सामग्रियों को संचित कर सकते हैं, जिन्हें आपने ऑनलाइन प्रशिक्षित किया है और उपयोगकर्ताओं की आदतों को समझने और उन समस्याओं को दूर करने के लिए अपने स्वयं के औजारों का उपयोग करते हैं, जिन पर आप अच्छे नहीं हैं। चूंकि आप जितनी बार चाहें उतनी बार परीक्षा की तैयारी कर सकते हैं, सभी स्कोर इतिहास और परीक्षा के समय को रिकॉर्ड कर सकते हैं, और इसे वास्तविक परीक्षा के दिन के करीब बना सकते हैं। इसके अलावा, आप प्रश्न को बेहतर ढंग से समझ सकते हैं क्योंकि यह आपकी अपनी भाषा और जापानी दोनों में लिखा गया है।",
    article5_sub2: "प्रवेश के समय अपना रिज्यूमे स्थायी रूप से सहेजें",
    article5_sub2_dec1: "जब आप विशिष्ट कौशल वीज़ा परीक्षण लेते हैं और वीज़ा के लिए आवेदन करते हैं, तो आपको एक तकनीकी प्रशिक्षु के रूप में जापान में प्रवेश करने पर फिर से शुरू करना होगा। मूल रूप से एक प्रबंधन संगठन (सहकारी) या संगठन भेजकर संग्रहीत किया जाता है, आप एक विशिष्ट कौशल वीजा प्राप्त करने के बाद इसे अपने आप से स्टोर कर सकते हैं।",
    article5_sub3: "आपके देश और क्षेत्र का पंजीकरण कार्य",
    article5_sub3_dec1: "चूंकि आपके अपने देश और जापान की भाषा का एक साथ उपयोग किया जाता है, इसलिए आप प्रश्नों को अच्छी तरह से समझ सकते हैं और प्रतिवाद कर सकते हैं। मूल परीक्षा में, केवल जापानी उपलब्ध है, इसलिए आप केवल जापानी में ही उपाय कर सकते हैं।",
    article5_sub4: "प्रमाणन परीक्षा आवश्यकताओं और सूचना के अनुस्मारक",
    article5_sub4_dec1: "जब प्रत्येक परीक्षण समूह द्वारा वांछित व्यवसाय के लिए परीक्षण अनुसूची एचपी पर अपलोड की जाती है, तो यह स्वचालित रूप से याद दिलाया जाएगा, उपयोगकर्ता को सूचित किया जाएगा, परीक्षण की तारीख उपयोगकर्ता स्क्रीन पर सेट की जाएगी, और टाइमर स्वचालित रूप से काम करेगा।",
    article5_sub5: "स्क्रीनिंग का उपयोग करते हुए सीखना",
    article5_sub5_dec1: "आप उपयोगकर्ता के कमजोर बिंदुओं को निकाल सकते हैं और परीक्षा की तैयारी कर सकते हैं।",
    article5_sub6: "स्मार्टफोन कैमरों का उपयोग करके ऑनलाइन शिक्षण परामर्श और साक्षात्कार।",
    article5_sub6_dec1: "एर का उपयोग करके परीक्षा की तैयारी के साथ आगे बढ़ते हुए, आप ऑनलाइन कॉल और चैट के रूप में प्रश्न के अर्थ और इरादे को स्पष्ट करने में सक्षम होंगे। यह उन लोगों के लिए आवश्यक नहीं हो सकता है जो जापान के आदी हैं या जो इससे परिचित हैं, लेकिन मूल कॉल परामर्श सेवा परीक्षा से पहले किसी भी चिंता की जांच करने का सबसे आश्वस्त तरीका है!",
    article6: "शुल्क",
    article6_sub1: "AELU उपयोग शुल्क",
    article6_sub1_dec1: "आप बिना किसी प्रतिबंध के विशिष्ट कौशल वीज़ा परीक्षण के लिए अध्ययन कर सकते हैं। आप अपनी मूल भाषा में ऑनलाइन परामर्श कर सकते हैं। * आप सामान्य समय के दौरान दुभाषिया के रूप में भी इसका उपयोग कर सकते हैं। परीक्षण के दिन परीक्षण स्थल पर \n घोषणा संभव है। \n प्रवेश पर फिर से शुरू को हमेशा के लिए बचाया जा सकता है। \n परीक्षा उत्तीर्ण करने के बाद, अपनी इच्छित नौकरी शुरू करने के लिए बस अपना विशिष्ट कौशल वीज़ा संख्या दर्ज करें। (दुविधा में पड़ा हुआ)।",
    article6_sub2: "परीक्षा आवेदन एजेंसी",
    article6_sub2_dec1: "आप काम के दौरान आवेदन नहीं कर सकते हैं, और जब तक आप आवेदन नहीं करते हैं, तब तक आप प्रमाणन परीक्षा नहीं दे पाएंगे, इसलिए प्रमाणन परीक्षा की जानकारी उपलब्ध होने पर हम तुरंत आवेदन करेंगे ताकि आप परीक्षा की तारीख को याद न करें।",
    article7: "कैशबैक अभियान प्रगति पर है!",
    article7_dec1: "परीक्षा उत्तीर्ण करने वालों से, जिन्होंने इस सेवा के लिए वीजा नंबर पंजीकृत किया है, उन्हें 5,000 \n येन का कैशबैक प्राप्त होगा! अभियान में भाग लेने के लिए यहां क्लिक करें।",
    article8: "अब AELU के साथ रजिस्टर करने देता है!",
    dashboard: "डैशबोर्ड",
    member_info: "प्रोफ़ाइल जानकारी का पंजीकरण",
    first_name: "नाम",
    midle_name: "मध्य नाम",
    family_name: "उपनाम",
    half_width_Roman: "रोमाजी आधी-चौड़ी",
    password: "पारण शब्द",
    password_confirm: "पासवर्ड पुष्टि",
    mail_adress: "मेल के पते",
    lineId: "लाइन आईडी",
    country_id: "कंट्री कोड",
    phone: "फ़ोन नंबर",
    issuing_country: "आईडी कार्ड जारी करने का देश / क्षेत्र चुनें",
    IDtype: "आईडी प्रकार चयन",
    residence_card: "निवास कार्ड या आईडी कार्ड",
    passport: "पासपोर्ट",
    regist: "पंजीकरण",
    is_required: "अनिवार्य है",
    sign_up: "साइन अप करें",
    residence_front: "सतह अपलोड",
    residence_back: "पीठ पर अपलोड करें",
    passport_upload: "अपना पासपोर्ट अपलोड करें",
    error_file: "कृपया छवि अपलोड करें",
    post_resume: "ब्यौरा देना",
    resume_upload: "रेज़्यूमे अपलोड करें",
    click_upload: "अपलोड करने के लिए क्लिक करें",
    image_drop: "या छवि फ़ाइल को खींचें और छोड़ें",
    select_language: "मातृभाषा का चुनाव",
    vietnamese: "वियतनामी",
    chinese: "चीनी",
    english: "अंग्रेज़ी",
    khmer: "खमेर",
    indonesian: "इन्डोनेशियाई",
    tagalog: "तागालोग",
    burmese: "बर्मी",
    hindu: "हिंदू",
    lao: "लाओ",
    mongolian: "मंगोलियन",
    bengali: "बंगाली",
    sinhala: "सिंहली",
    banglodesh: "बांग्लादेशी",
    malay: "मलायी",
    nepali: "नेपाली",
    thai: "थाई",
    japanese: "जापानी",
    error_lang: "कृपया अपनी मूल भाषा चुनें।",
    select_ouccupation: "नौकरी प्रकार चयन",
    select_max_three: "आप तीन तक का चयन कर सकते हैं।",
    industry_id_1: "दीर्घकालिक देखभाल उद्योग",
    industry_id_2: "सफाई व्यवसाय का निर्माण",
    industry_id_3: "कच्चा माल उद्योग",
    industry_id_4: "औद्योगिक मशीनरी विनिर्माण उद्योग",
    industry_id_5: "इलेक्ट्रिकल और इलेक्ट्रॉनिक सूचना संबंधित उद्योग",
    industry_id_6: "निर्माण उद्योग",
    industry_id_7: "जहाज निर्माण / समुद्री उद्योग",
    industry_id_8: "कार रखरखाव उद्योग",
    industry_id_9: "उड्डयन उद्योग",
    industry_id_10: "आवास व्यवसाय",
    industry_id_11: "कृषि",
    industry_id_12: "मछली पकड़ना",
    industry_id_13: "खाद्य और पेय विनिर्माण",
    industry_id_14: "रेस्तरां व्यवसाय",
    industry: "उद्योग",
    error_occupation: "कृपया एक या अधिक नौकरी प्रकार चुनें।",
    do: "ऐसा करने के लिए",
    news_tpic: "समाचार",
    days_until_exam: "परीक्षा के दिनों तक शेष है",
    estimated_pass_rate: "अनुमानित दर",
    average_score_taken: "लिए गए टेस्ट का औसत स्कोर",
    exam: "परीक्षा है",
    let_aim: "के लिए लक्ष्य देता है",
    score: "बिंदु",
    solve_problem: "प्रश्न हल करें",
    recommend_problem: "AELUs प्रश्न की सिफारिश की",
    solved_problem: "अतीत में हल किया गया प्रश्न",
    looking_solved: "पिछले प्रश्नों की जाँच करें",
    consultaion_service: "परामर्श सेवा सीखना",
    application_agency: "परीक्षा आवेदन एजेंसी सेवा",
    billing: "बिलिंग",
    more_look: "अधिक जांचें",
    more_look2: "अधिक जांचें",
    facebook: "फेसबुक",
    google: "गूगल",
    until_not_account: "यदि आपके पास अभी तक कोई खाता नहीं है",
    or: "या",
    other_way: "दूसरे तरीके में",
    not_have_account: "यदि आपके पास खाता नहीं है",
    have_account: "अगर आपका खाता है",
    forgot_password: "अगर आप अपना पासवर्ड भूल गए हैं",
    this: "यहाँ",
    at_login: "से लोगिन करें",
    pass_condition: "8 या अधिक एकल-बाइट अल्फ़ान्यूमेरिक कैपिटल अक्षर",
    at_sign_up: "के साथ नया पंजीकरण",
    agreement1: "निम्नलिखित पर सहमति व्यक्त करते हुए और जारी रखने के लिए चुनते हुए, ए.एल.यू.",
    terms: "सेवा की शर्तें",
    agreement2: "मैं आपसे सहमत हूं।",
    agree: "स्वीकार करें एवं आगे बढ़ें",
    account_confirm: "पुष्टि कोड",
    confirm: "पुष्टीकरण",
    not_confirm: "पुष्टिकरण कोड अपुष्ट है।",
    move_confiirm: "पुष्टि कोड इनपुट स्क्रीन पर ले जाता है",
    top: "ऊपर",
    news_list: "समाचार सूची",
    problim_list: "प्रश्न सूची",
    learning_consul: "परामर्श सीखना",
    agency: "परीक्षा की जानकारी",
    of_trend: "परीक्षण की प्रवृत्ति के बारे में",
    start_test: "परीक्षण शुरू करें",
    study_mode: "लर्निंग मोड",
    order_question: "सवाल",
    of_question: "प्रश्न में",
    question_current: "प्रश्न सही उत्तर",
    to_mypage: "मेरे पेज पर",
    correct_answer: "सही जवाब!",
    correct_answer_normal: "सही जवाब",
    no_correct_answer: "ग़लत उत्तर",
    next: "अगले सवाल पर",
    finish_all: "सभी सवालों के जवाब दिए!",
    your_score: "आपका स्कोर है",
    is: "है!",
    result_description: "आप दृश्य प्रश्न सूची से अन्य प्रश्नों को हल कर सकते हैं। आप उन प्रश्नों पर भी वापस देख सकते हैं जो आपने प्रश्न सूची पृष्ठ से अतीत में हल किए हैं।",
    back_quiz_list: "प्रश्न सूची की जाँच करें",
    retry: "इस प्रश्न को फिर से हल करें",
    no_description: "कोई स्पष्टीकरण नहीं है",
    show_ans: "उत्तर की जाँच करें",
    of_solved_problem: "अतीत में हल किया गया प्रश्न",
    of_solved_problem_list: "अतीत में हल किए गए प्रश्नों की सूची",
    solved_description: "आप दीर्घकालिक देखभाल उद्योग के विशिष्ट कौशल वीज़ा परीक्षण के लिए फिर से सीखने की परीक्षा की जांच कर सकते हैं।",
    before_result: "पिछले परिणाम",
    looking_back: "फिर से जाँचो",
    back_solved_problem_list: "अतीत में हल किए गए प्रश्नों की एक सूची देखें",
    again_retry: "इस सवाल पर फिर से गौर करना",
    done_member_regist: "एक सदस्य के रूप में पंजीकरण के लिए धन्यवाद!",
    done_member_regist_description: "सेवा उपयोग शुल्क का भुगतान करने के बाद प्रत्येक सेवा उपलब्ध होगी। \n कृपया अपनी भुगतान जानकारी पंजीकृत करें।",
    choose_payment: "भुगतान करने का माध्यम चुनें",
    service_content: "सेवा सामग्री",
    test_info_service: "परीक्षा सूचना सेवा",
    usage_fee: "उपयोग शुल्क",
    test_fee: "500 येन + कर",
    application_fee: "20000 येन + कर",
    method_payment: "भुगतान का तरीका",
    LINE_pay: "लाइन पे",
    line_pay_description: "* कृपया QR कोड छवि सहेजें और LINE पे सेवा के भीतर भुगतान करें। लाइन पे के साथ भुगतान करते समय प्रबंधन को पुष्टि करने में समय लगेगा।",
    save_qr: "QR कोड सेव करें",
    next_stage: "अगला",
    credit_card: "क्रेडिट कार्ड",
    copmplete_payment: "भुगतान पूरा हो गया है।",
    copmplete_payment_descript: "अब जब भुगतान पूरा हो गया है, तो आप ऑनलाइन परीक्षा अध्ययन समारोह, परीक्षा की जानकारी और आवेदन एजेंसी सेवा का उपयोग कर सकते हैं।",
    start_sevice: "सेवा का उपयोग शुरू करें",
    to_payment: "स्क्रीन का भुगतान करने के लिए",
    of_news_list: "समाचार सूची",
    done_payment: "भुगतान पूरा हो चुका है।",
    tv_consult: "विडियोफोन परामर्श",
    tell_consult: "टेलीफोन परामर्श",
    learning_consul_descript01: "परीक्षा आवेदन",
    learning_consul_descript02: "हम आपकी ओर से कार्रवाई करेंगे",
    money_unit: "JPY",
    learning_consul_unit: "एक बार",
    fault_payment1: "भुगतान विफल रही।",
    fault_payment2: "कृपया पुन: प्रयास करें।",
    no_examination: "अभी तक नहीं",
    no_exam: "अभी तक कोई परीक्षा नहीं हुई",
    undecided: "दुविधा में पड़ा हुआ",
    retry_login: "कृपया फिर भाग लें",
    no_problem: "कोई प्रश्न हल नहीं किया है",
    do_problem: "प्रश्न हल करें",
    qa_title: "बार बार पूछे जाने वाले प्रश्न",
    search_category: "श्रेणी के अनुसार कम करें",
    search_freeward: "मुक्त शब्द द्वारा खोजें",
    test_result: "परीक्षा परिणाम का अभ्यास करें",
    to_top: "सबसे ऊपर",
    missPassword: "गलत पासवर्ड या ईमेल पता",
    sample_problem: "एक ऑनलाइन परीक्षा के लिए अध्ययन का अनुभव",
    exercises: "अभ्यास",
    let_exercises: "आइए केवल एक वास्तविक समस्या का समाधान करें!",
    to_qa: "अधिक प्रश्नोत्तर देखें",
    read_more: "अधिक जांचें",
    account_setting: "खाता समायोजन",
    profile_setting: "पार्श्वचित्र समायोजन",
    notification_setting: "अधिसूचना सेटिंग",
    logout: "लॉग आउट",
    changeEmail: "ईमेल पता बदलें",
    changePassword: "पासवर्ड बदलें",
    change: "परिवर्तन",
    save: "सहेजें",
    change_success: "बदलाव पूरा हुआ",
    now_password: "वर्तमान पासवर्ड",
    new_password: "नया पासवर्ड",
    check_new_password: "नया पासवर्ड पुष्टि)",
    do_logout: "बाहर आ गये",
    done_learning_consul_payment: "भुगतान पूरा हो चुका है।",
    past_exam: "विगत प्रश्न",
    update_info: "नवीनतम जानकारी को अद्यतन करना",
    official_sns: "आधिकारिक एसएनएस",
    privacy_policy: "गोपनीयता नीति",
    terms_service: "सेवा की शर्तें",
    transaction_law: "निर्दिष्ट वाणिज्यिक लेनदेन कानून के आधार पर अधिसूचना",
    selectCountry: "कृपया देश को चुनें",
    goInquiry: "पूछताछ के लिए आगे बढ़ें",
    lineInquiry: "लाइन के माध्यम से हमसे संपर्क करें",
    regist_accept_certificate: "विशिष्ट कौशल वीज़ा अधिग्रहण पास प्रमाण पत्र का पंजीकरण",
    accept_certificate_description: "आप अपना पास सर्टिफिकेट और नंबर रजिस्टर कर सकते हैं",
    accept_certificate: "स्वीकृति का प्रमाण पत्र",
    accept_number: "पास नंबर",
    immigration_resume: "प्रवेश के समय पंजीकरण फिर से शुरू करें",
    resendCode: "सत्यापन कोड पुनः भेजें",
    line_at_register: "लाइन @ के माध्यम से सेवा पूछताछ",
    study: "अध्ययन और फिर से जाँच करें",
    study_text: "पाठ सीखना डाउनलोड करें",
    do_resume_update: "कृपया अपना रिज्यूमे अपलोड करें",
    done_resume_update: "अपना रिज्यूमे दर्ज करने के लिए धन्यवाद!",
    regist_resume_enter: "प्रवेश के समय फिर से शुरू करने का पंजीकरण",
    about_company: "ऑपरेटिंग कंपनी के बारे में",
    add_exam_info_detail: "परीक्षा की जानकारी जोड़ी गई है। विवरण और आवेदन के लिए यहां क्लिक करें",
    regist_result_get_money: "अपना परीक्षा परिणाम पंजीकृत करें और अपना पैसा प्राप्त करें",
    detail: "विवरण",
    about_withdrawal_subsc: "सदस्यता को वापस लेने और रद्द करने के बारे में",
    apply_withdrawal: "सदस्यता समाप्त करने के लिए आवेदन",
    apply_subsc: "सदस्यता से सदस्यता समाप्त करने के लिए आवेदन",
    about_withdrawal: "निकासी आवेदन",
    about_subsc: "सदस्यता से सदस्यता समाप्त करें",
    exam_info: "परीक्षा की जानकारी",
    date: "तिथि और समय",
    day: "दिन",
    place: "जगह",
    result_publication: "परिणाम प्रकाशन",
    result_publication_place: "परिणाम घोषित करने का स्थान",
    result_this_page: "इस पृष्ठ पर घोषित किया जाएगा",
    exam_way: "परीक्षा का प्रारूप",
    exam_way2: "परीक्षा का प्रारूप",
    include_exam_fee: "जिसमें परीक्षा शुल्क भी शामिल है",
    exam_application_desc: "परीक्षा आवेदन पत्र प्रस्तुत करना। परीक्षा कार्यालय के साथ बातचीत करना",
    self_application: "खुद से आवेदन करें",
    application_method: "आवेदन कैसे करें",
    under_this_url: "कृपया निम्न URL से आवेदन प्रक्रिया पूरी करें।",
    do_appliction: "परीक्षा के लिए आवेदन करें",
    study_with_aeru: "पास दर बढ़ाने के लिए शीर्ष पृष्ठ से परीक्षा अध्ययन समारोह का उपयोग करें।",
    line_at_consul: "LINE @ शिक्षण परामर्श सेवा",
    instagram: "instagram",
    do_signup: "आपको प्रमाणित किया गया है। \n कृपया फिर से लॉग इन करें।",
    gender: "लिंग",
    man: "पुरुष",
    woman: "महिला",
    input_problem_title: "समस्या का शीर्षक शामिल है ...",
    still_no_problem: "कोई दिक्कत नहीं है",
    enter_in_problem_trend: "परीक्षा के संक्षिप्त विवरण और अब तक के उत्तर प्रारूप (चयन प्रकार) जैसे परीक्षा का संक्षिप्त विवरण समाहित करता है।",
    correct: "सही जवाब",
    explanation: "व्याख्या",
    problem: "सवाल",
    do_nursing_not_published: "लंबी अवधि के देखभाल उद्योग में परीक्षा आयोजित की जा रही है लेकिन पिछले प्रश्न प्रकाशित नहीं हुए हैं।",
    practical_exam_of_year: "वर्ष व्यावहारिक परीक्षण",
    judgment_test_of_year: "2019 की जजमेंट परीक्षा",
    judgment_test_answer_of_year: "2019 जजमेंट एग्जाम आंसर",
    not_yet_test_material: "अभी कच्चे माल उद्योग में परीक्षा नहीं हुई है",
    not_yet_test_machinery: "औद्योगिक मशीनरी विनिर्माण क्षेत्र में अभी तक परीक्षा नहीं हुई है",
    not_yet_test_electronic: "अभी तक इलेक्ट्रिकल और इलेक्ट्रॉनिक से संबंधित उद्योग में परीक्षा नहीं हुई है",
    not_yet_test_construction: "अभी तक निर्माण उद्योग में परीक्षा नहीं हुई",
    not_yet_test_shipbuilding: "अभी तक जहाज निर्माण और समुद्री उद्योग में परीक्षा नहीं हुई है",
    do_automobile_not_published: "ऑटोमोबाइल रखरखाव के क्षेत्र में परीक्षा आयोजित की जा रही है लेकिन पिछले प्रश्न प्रकाशित नहीं हुए हैं।",
    do_aviation_not_published: "उड्डयन उद्योग में परीक्षा आयोजित की जा रही है लेकिन पिछले प्रश्न प्रकाशित नहीं हुए हैं।",
    do_agricultural_not_published: "कृषि क्षेत्र में परीक्षाएं आयोजित की जा रही हैं लेकिन पिछले प्रश्नों को प्रकाशित नहीं किया गया है।",
    do_fishery_not_published: "मत्स्य क्षेत्र में परीक्षा आयोजित की जा रही है लेकिन पिछले प्रश्न प्रकाशित नहीं हुए हैं।",
    do_food_not_published: "खाद्य और पेय निर्माण उद्योग में परीक्षा आयोजित की जा रही है लेकिन पिछले प्रश्न प्रकाशित नहीं हुए हैं।",
    do_restaurant_not_published: "खाद्य सेवा उद्योग में परीक्षा आयोजित की जा रही है लेकिन पिछले प्रश्न प्रकाशित नहीं हुए हैं।",
    schedule_undecided: "(* अनुसूची अनिर्दिष्ट है)",
    year: "साल",
    month: "चांद",
    texts_learning: "प्रत्येक उद्योग को सीखने के लिए पाठ्यपुस्तकें",
    texts_learning_test: "विशिष्ट कौशल मूल्यांकन परीक्षा सीखने का पाठ (जापानी)",
    skill_test_sample: "कौशल मूल्यांकन परीक्षा नमूना",
    japanese_test_sample: "जापानी मूल्यांकन परीक्षा नमूना",
    not_building_texts: "भवन निर्माण उद्योग के लिए कोई पाठ्यपुस्तक अभी तक उपलब्ध नहीं है।",
    not_material_texts: "कच्चे माल उद्योग के लिए अभी तक कोई पाठ्यपुस्तक नहीं है।",
    not_machinery_texts: "औद्योगिक मशीनरी निर्माण के क्षेत्र में अभी तक कोई पाठ्यपुस्तक नहीं है।",
    not_electronic_texts: "इलेक्ट्रिकल और इलेक्ट्रॉनिक सूचना से संबंधित उद्योगों के लिए कोई पाठ्यपुस्तक अभी तक उपलब्ध नहीं है।",
    not_shipbuilding_texts: "जहाज निर्माण / समुद्री उद्योग के लिए अभी तक कोई पाठ्यपुस्तक नहीं है।",
    not_automobile_texts: "ऑटोमोबाइल रखरखाव उद्योग के लिए अभी तक कोई पाठ्यपुस्तक नहीं है।",
    not_accommodation_texts: "आवास उद्योग के लिए अभी तक कोई पाठ्यपुस्तक नहीं है।",
    not_food_texts: "खाद्य और पेय विनिर्माण उद्योग के लिए अभी तक कोई पाठ्यपुस्तक नहीं है।",
    not_restaurant_texts: "खाद्य सेवा कौशल माप परीक्षा पाठ्यपुस्तक सीखना",
    each_depertment_texts: "प्रत्येक विभाग में परीक्षा सीखने के लिए पाठ्यपुस्तकें",
    skill_test_basic: "कौशल मूल्यांकन परीक्षा सीखने का पाठ (बुनियादी तकनीक)",
    skill_test_safety: "कौशल मूल्यांकन परीक्षा शिक्षण पाठ (कार्य सुरक्षा / गुणवत्ता)",
    skill_test_aircraft: "कौशल मूल्यांकन परीक्षा शिक्षण पाठ (विमान अवलोकन)",
    texts_livestock: "[पशुधन खेती सीखने के लिए पाठ्यपुस्तक] जापानी संस्करण",
    texts_cultivated: "[खेती कृषि सीखने का पाठ] जापानी संस्करण",
    skill_test_fishery: "मत्स्य कौशल मापन परीक्षा (मत्स्य)",
    skill_test_general_fishery: "मत्स्य कौशल मापन परीक्षा (सामान्य मत्स्य)",
    skill_test_safety_fishery: "मत्स्य कौशल मापन परीक्षा (मत्स्य सुरक्षा)",
    skill_test_specialty_fishery: "मत्स्य कौशल मापन परीक्षा (मत्स्य विशेष नेट संबंधित)",
    skill_test_related_fishery: "मत्स्य कौशल मापन परीक्षा (मत्स्य विशेष मत्स्य पालन संबंधित)",
    skill_test_aquaculture: "मत्स्य कौशल मापन परीक्षा (एक्वाकल्चर)",
    skill_test_general_aquaculture: "मत्स्य कौशल मापन परीक्षा (एक्वाकल्चर जनरल / सुरक्षा)",
    skill_test_feeding_aquaculture: "मत्स्य कौशल माप परीक्षा (भोजन और जलीय कृषि)",
    skill_test_non_feeding_aquaculture: "मत्स्य कौशल माप परीक्षा (संबंधित एक्वाकल्चर से संबंधित)",
    registration_skill_visa: "विशिष्ट कौशल वीजा की स्वीकृति के प्रमाण पत्र का पंजीकरण",
    please_register_pdf_number: "विशिष्ट प्रमाणपत्र प्राप्त करने के लिए कृपया पास सर्टिफिकेट की फोटो या पीडीएफ रजिस्टर करें और पास सर्टिफिकेट पर पास नंबर दें।",
    regist_and_get_cash_bag: "यदि आप अभी पंजीकरण करते हैं, तो आप नकद बैग के साथ 5000 येन प्राप्त कर सकते हैं।",
    thank_you_regist_visa_pass: "विशिष्ट कौशल वीज़ा पास करने का प्रमाण पत्र पंजीकृत करने के लिए धन्यवाद!",
    exam_info_detail: "परीक्षा कार्यान्वयन की रूपरेखा",
    em_exam_detail_language: "स्थानीय भाषा में किया जाना निर्धारित है",
    em_exam_detail_method: "विभाग परीक्षा, व्यावहारिक परीक्षा",
    em_exam_detail_way: "कंप्यूटर आधारित परीक्षण (सीबीटी) कागज परीक्षण विधि या उत्पादन जैसे कार्य परीक्षण विधि",
    em_exam_detail_section: "19 परीक्षा श्रेणियां (कास्टिंग, फोर्जिंग, डाई कास्टिंग, मशीनिंग, मेटल स्टैम्पिंग, आयरनवर्क, फैक्ट्री शीट मेटल, चढ़ाना, एल्युमिनियम एनोडाइजेशन, फिनिशिंग, मैकेनिकल इंस्पेक्शन, मशीन मेंटेनेंस, इलेक्ट्रॉनिक उपकरण असेंबली, इलेक्ट्रिकल इक्विपमेंट असेंबली, प्रिंटेड वायरिंग बोर्ड मैन्युफैक्चरिंग, प्लास्टिक मोल्डिंग) , पेंटिंग, वेल्डिंग, औद्योगिक पैकेजिंग)",
    em_exam_detail_notify: "परीक्षा के बाद, परिणाम की सूचना ईमेल द्वारा भेजें।",
    em_exam_detail_border: "विभाग परीक्षण: 65% या अधिक \n व्यावहारिक परीक्षण: 60 अंक या अधिक",
    ss_exam_detail_language: "जापानी",
    ss_exam_detail_method: "प्रवीणता परीक्षा एक व्यावहारिक परीक्षण और एक विभाग परीक्षण द्वारा आयोजित की जाती है। \n प्रत्येक व्यवसाय श्रेणी के लिए व्यावहारिक परीक्षा आयोजित की जाती है। \n विभाग की परीक्षा प्रत्येक व्यावसायिक श्रेणी के लिए पेपर टेस्ट विधि द्वारा आयोजित की जाती है।",
    ss_exam_detail_way: "कागज परीक्षण विधि, आदि",
    ss_exam_detail_section: "विभाग / अभ्यास / कौशल: वेल्डिंग, पेंटिंग, लोहा, परिष्करण, मशीनिंग, बिजली के उपकरण विधानसभा",
    ss_exam_detail_notify: "-",
    ss_exam_detail_border: "विभाग परीक्षण: 60% या अधिक \n व्यावहारिक परीक्षण: व्यावहारिक परिणामों के आधार पर निर्णय",
    c_exam_detail_language: "जापानी",
    c_exam_detail_method: "प्रवीणता परीक्षा एक व्यावहारिक परीक्षण और एक विभाग परीक्षण द्वारा आयोजित की जाती है।",
    c_exam_detail_way: "कंप्यूटर आधारित परीक्षण (सीबीटी), व्यावहारिक परीक्षण एक पंजीकृत निगम द्वारा निर्दिष्ट विधि है",
    c_exam_detail_section: "-",
    c_exam_detail_notify: "वेबसाइट पर प्रकाशित",
    c_exam_detail_border: "विभाग परीक्षण: 65% या अधिक \n व्यावहारिक परीक्षण: व्यावहारिक परिणामों के आधार पर निर्णय",
    cm_exam_detail_language: "जापानी",
    cm_exam_detail_method: "प्रवीणता परीक्षा एक व्यावहारिक परीक्षण और एक विभाग परीक्षण द्वारा आयोजित की जाती है।",
    cm_exam_detail_way: "कंप्यूटर-आधारित परीक्षण (CBT) द्वारा शैक्षणिक और व्यावहारिक परीक्षाएँ",
    cm_exam_detail_section: "विषय की परीक्षा के विषय संरचना, कार्य और हैंडलिंग विधि के बारे में प्राथमिक ज्ञान \n निरीक्षण, मरम्मत और समायोजन के बारे में प्राथमिक ज्ञान सामग्री और ईंधन और वसा और वसा की जांच के गुणों के बारे में \n व्यावसायिक परीक्षा के विषय \n सरल बुनियादी काम \n Disassembly, विधानसभा, सरल निरीक्षण और समायोजन \n आसान रखरखाव मरम्मत मशीनों, उपकरणों और उपकरणों को मापने के लिए आसान मरम्मत \n।",
    cm_exam_detail_notify: '',
    cm_exam_detail_border: "विभाग परीक्षण: 65% या अधिक प्रैक्टिकल परीक्षण: कुल स्कोर 60% या अधिक",
    a_exam_detail_language: "स्थानीय भाषा और जापानी",
    a_exam_detail_way: "कंप्यूटर आधारित परीक्षण (सीबीटी), पेपर टेस्ट विधि",
    a_exam_detail_section: "विभाग ने सामान्य, सुरक्षा और स्वास्थ्य, खेती की गई फसलों की किस्मों / विशेषताओं, खेती के वातावरण (सुविधा / उपकरण / सामग्री / मशीनरी), खेती के तरीके / प्रबंधन, कीट / खरपतवार नियंत्रण, कटाई / समायोजन / भंडारण / शिपिंग ract जैविक मिट्टी के अवलोकन में कृषि की खेती की। उर्वरकों / कीटनाशकों का संचालन, बीजों का संचालन, पर्यावरण प्रबंधन, सामग्री / उपकरण / मशीनों का संचालन, खेती से संबंधित कार्य, सुरक्षा और स्वास्थ्य safety जापानी कार्यों में दिए गए कृषि कार्यों की सामग्री को सुनना",
    a_exam_detail_notify: "वेबसाइट पर प्रकाशित",
    a_exam_detail_border: "कुल अंक राष्ट्रीय कृषि मंडल द्वारा निर्धारित निर्णय संदर्भ बिंदु से अधिक है।",
    avi_exam_detail_method: "प्रवीणता परीक्षा एक व्यावहारिक परीक्षा और एक विभाग परीक्षा द्वारा आयोजित की जाती है।",
    avi_exam_detail_section: "प्रश्न जापान एविएशन टेक्नोलॉजी एसोसिएशन की वेबसाइट पर पोस्ट किए गए ग्रंथों से दिए जाएंगे। व्यावहारिक कौशल निष्कर्ष, विद्युत माप",
    avi_exam_detail_notify: '',
    avi_exam_detail_border: "विभाग का परीक्षण: 65% या अधिक प्रैक्टिकल परीक्षण: कुल स्कोर 65% या अधिक",
    f_exam_detail_language: "जापानी",
    f_exam_detail_method: "प्रवीणता परीक्षा एक व्यावहारिक परीक्षण और एक विभाग परीक्षण द्वारा आयोजित की जाती है।",
    f_exam_detail_way: "कंप्यूटर-आधारित परीक्षण (CBT) द्वारा शैक्षणिक और व्यावहारिक परीक्षाएँ",
    f_exam_detail_section: "परीक्षण विषय इस बात की पुष्टि करेगा कि मत्स्य क्षेत्र (मत्स्य) या मत्स्य क्षेत्र (एक्वाकल्चर) में कुछ हद तक कार्य पर्यवेक्षक के निर्देशों को समझकर सही तरीके से किया जा सकता है या अपने विवेक से किया जा सकता है, और केवल विशेष है । यह ज्ञान की उपस्थिति या अनुपस्थिति का मूल्यांकन नहीं है, बल्कि मत्स्य क्षेत्र (मत्स्य) या मत्स्य क्षेत्र (एक्वाकल्चर) में कार्य करने के लिए आवश्यक सही निर्णय और कार्य ज्ञान की उपस्थिति या अनुपस्थिति का मूल्यांकन करना भी संभव है।",
    f_exam_detail_notify: "वेबसाइट पर प्रकाशित",
    f_exam_detail_border: "जिनकी लिखित परीक्षा और प्रैक्टिकल टेस्ट का कुल स्कोर प्रवीणता परीक्षा निष्पादन एजेंसी द्वारा निर्धारित निर्णय मानक स्कोर से अधिक है।",
    no_exam_info: "अभी तक कोई परीक्षण सारांश जानकारी जारी नहीं की गई है",
    language: "कार्यान्वयन की भाषा",
    method: "कार्यान्वयन विधि",
    way: "कार्यान्वयन विधि",
    section: "छूट श्रेणी",
    notify: "परीक्षा परिणाम की अधिसूचना",
    border: "परीक्षा परिणाम मानदंड",
    go_line_at: "कतार करना @",
    thank_you_and_deactivate: "उपयोग करने के लिए धन्यवाद। सेवा से हटने की प्रक्रिया के लिए, कृपया नीचे दिए गए लाइन @ विंडो से निकासी की प्रक्रिया दर्ज करें। नियमित भुगतान को रद्द करने के लिए, कृपया नीचे दिए गए लाइन @ विंडो से नियमित भुगतान को रद्द करें। पुष्टि मिलते ही हम प्रक्रिया को आगे बढ़ाएंगे।",
    thank_you_and_subscribe: "उपयोग करने के लिए आपका धन्यवाद। नियमित भुगतान को रद्द करने के लिए, कृपया नीचे दिए गए लाइन @ विंडो से नियमित भुगतान को रद्द करें। \n हम पुष्टि प्राप्त करते ही अनुबंध रद्द कर देंगे।",
    ten_thousand_yen: "दस हजार येन",
    yen_per_month: "जेपीवाई / महीना",
    how_to_use_this_service: "उपयोग का प्रवाह",
    selecting_a_browser: "ब्राउज़र चयन",
    selecting_a_browser_dec: "एक ब्राउज़र (Google chrome, Safari, edge, आदि) के साथ https://aelu.co.jp पर पहुँचें। * कोई ऐप नहीं है।",
    provisional_registration: "अस्थायी पंजीकरण",
    provisional_registration_dec: "अपने फेसबुक या Google आईडी से लॉग इन करें या अपने ईमेल पते के साथ पंजीकरण करें। वांछित भाषा और वांछित व्यवसाय का चयन करने के बाद, आप ऑनलाइन प्रमाणन परीक्षा नकली सामग्री ब्राउज़ कर सकते हैं।",
    full_registration: "मुख्य पंजीकरण",
    full_registration_dec: "ऑनलाइन प्रमाणन परीक्षा सामग्री पृष्ठ पर मुख्य पंजीकरण पर क्लिक करें, आवश्यक जानकारी भरें, और 14 उद्योग प्रमाणन परीक्षा अभ्यास प्रश्नों सहित सभी सेवाओं का उपयोग करें।",
    name_validate_message: "कृपया सूचना उसी स्पेलिंग के साथ दर्ज करें जैसा कि आपके पासपोर्ट पर दिखाई देती है।",
    live_at_area: "वह क्षेत्र जहाँ आप वर्तमान में रहते हैं",
    agency_application: "परीक्षा आवेदन के लिए अभिनय",
    mypage: "मेरा पेज",
    myanmar: "बर्मी",
    exam_list: "परीक्षा अनुसूची सूची",
    no: "नहीं।",
    times: "बार",
    application_start: "आवेदन शुरू करें",
    application_end: "आवेदन की समय सीमा",
    enforcement: "कार्यान्वयन",
    applicated: "लागू",
    reception_time: "रिसेप्शन का समय",
    announthment_d: "स्वीकृति की घोषणा की तारीख",
    reception_period: "आवेदन की अवधि",
    detail_link: "विवरण की जाँच करें",
    exam_country: "अतिथि देश",
    line: "लाइन",
    vietnum: "वियतनाम",
    laos: "लाओस",
    malaysia: "मलेशिया",
    bangladesh: "बांग्लादेश",
    indo: "भारत",
    nepal: "नेपाल",
    mongol: "मंगोलिया",
    indonesia: "इंडोनेशिया",
    th: "थाईलैंड",
    philipine: "फिलीपींस",
    my: "म्यांमार",
    uzbekistan: "उज़्बेकिस्तान",
    pakistan: "पाकिस्तान",
    japan: "जापान",
    news_title: "विशिष्ट कौशल वीजा के बारे में समाचार",
    missNowPassword: "वर्तमान पासवर्ड गलत है",
    article6_sub2_dec2: "यदि आप यहां आवेदन करते हैं, तो हम परीक्षा के आवेदन, परीक्षा की कीमत और परीक्षा के दिन तक के कार्यक्रम की भी घोषणा करेंगे।",
    create_naw_password: "पासवर्ड बदलें",
    send_confirmcode: "एक सत्यापन कोड भेजा गया है",
    edit: "परिवर्तन",
    success_new_password_setting: "आपने एक नया पासवर्ड सेट किया है।",
    error_email: "यह एक अपंजीकृत ईमेल पता है।",

    click_here_businesses: "&quot;व्यवसायों के लिए यहां क्लिक करें&quot;",
    regist_organization_staff_info: "व्यवसाय का पंजीकरण / उपयोगकर्ता जानकारी",
    organization_info: "व्यवसाय जानकारी",
    staff_info: "यूजर जानकारी",
    org_name: "व्यवास्यक नाम",
    url: "यूआरएल",
    org_scale: "पैमाना",
    org_zip: "डाक कोड",
    org_adress1: "प्रीफेक्चर",
    org_adress2: "Faridabad",
    org_adress3: "पता/अपार्टमेंट का नाम",
    org_industry: "उद्योग",
    org_category: "वर्ग",
    org_description: "विवरण",
    org_established_at: "स्थापना वर्ष",
    org_phone: "बिजनेस फोन नंबर",
    failed_established_at: "अमान्य तिथि। ",
    staff_name: "उपयोगकर्ता नाम",
    form_miss: "इनपुट फॉर्म में गलती है। ",

    back_joboffer_detail: "नौकरी के विवरण पर लौटें <",
    create_joboffer: "नौकरी बनाएँ",
    edit_joboffer: "नौकरियां संपादित करें",
    stop_posting: "पोस्ट करना बंद करो",
    delete: "&quot;हटाएं&quot;",
    job_title: "नौकरी का नाम",
    job_catch_phrase: "जॉब कैच कॉपी",
    job_category: "व्यवसाय श्रेणी",
    employed_company_name: "कर्मचारी कंपनी का नाम",
    work_location: "कार्य स्थल",
    employment_status: "रोज़गार की स्थिति",
    full_time_employee: "नियमित कर्मचारी",
    part_time_job: "अंशकालिक नौकरी",
    temporary_staff: "भेजे गए मजदूर",
    contract_employee: "संविदा कर्मचारी",
    intern: "इंटर्न",
    subcontracting: "उपठेकेदार",
    contract: "अनुबंध",
    new_graduate: "नए स्नातक",
    salary: "वेतन",
    annual_income: "वार्षिक आय",
    monthly_salary: "मासिक वेतन",
    weekly_salary: "साप्ताहिक वेतन",
    dayly_salary: "दैनिक वेतन",
    job_offer_attension1: "कार्य सामग्री के लिए कानून के अनुसार निर्धारित कार्य शर्तों आदि को निर्दिष्ट करना आवश्यक है",
    job_offer_attension2: "कृपया काम करने की परिस्थितियों आदि की जांच करें, जिन्हें कानून द्वारा स्पष्ट रूप से कहा जाना आवश्यक है, और फिर कार्य सामग्री का वर्णन करें। (संदर्भ: स्वास्थ्य, श्रम और कल्याण मंत्रालय, प्रीफेक्चुरल लेबर ब्यूरो &quot;श्रमिकों की भर्ती करने वाली सभी कंपनियों के लिए&quot;)",
    job_offer_attension3: "यदि आप लक्षित व्यक्ति की उम्र, लिंग या सामाजिक स्थिति को सीमित करने वाली भाषा का उपयोग करते हैं तो आप नौकरी पोस्ट करने में सक्षम नहीं हो सकते हैं। ",
    job_offer_attension4: "अक्सर अप्रकाशित उदाहरण: &quot;20 के दशक में आपका स्वागत है&quot; &quot;युवा लोगों में आपका स्वागत है&quot; &quot;महिलाओं का स्वागत / सीमित&quot; &quot;केवल छात्र&quot;",
    work_content_appeal: "नौकरी सामग्री और अपील बिंदु",
    work_content_appeal_desc: "नौकरी चाहने वालों के लिए दिलचस्पी लेना आसान होगा यदि आप उन्हें पहले अपील बिंदु बताएं। ",
    human_resources_seek: "मानव संसाधन तलाशने के लिए",
    human_resources_seek_desc: "न केवल वे कौशल जिनकी आप तलाश कर रहे हैं, बल्कि ऐसी जानकारी भी है जो नौकरी चाहने वालों को कार्यस्थल की कल्पना करने की अनुमति देती है। ",
    working_hours: "काम करने के घंटे",
    traffic_access: "यातायात पहुंच",
    traffic_access_desc: "न केवल सार्वजनिक परिवहन की जानकारी, बल्कि कार से यात्रा करना, चाहे कर्मचारियों के लिए पार्किंग स्थल हो, आदि। ",
    required: "आवश्यक",
    optional: "कोई भी",
    other: "अन्य",
    photo: "तस्वीर",
    upload_video: "विडियो को अॅॅपलोड करें",
    job_tag: "जॉब टैग",
    until_select_three: "अधिकतम 3 चयन योग्य",
    senior_support: "वरिष्ठ समर्थन",
    salary_increase_promotion: "वेतन वृद्धि/पदोन्नति उपलब्ध",
    no_overtime: "कोई ओवरटाइम नहीं",
    target_hiring_time: "भर्ती लक्ष्य समय",
    additional_questions: "अतिरिक्त प्रशन",
    job_offer_title: "कार्य नाम",
    public: "रिलीज",
    private: "निजी",
    public_status: "सार्वजनिक स्थिति",
    occupation: "व्यवसाय",
    walfare: "उपचार / लाभ",
    create: "&quot;सृजन करना&quot;",
    hour: "समय",
    back_mypage: "मेरे पृष्ठ पर लौटें <",
    job_offers: "नौकरी की सूची",
    look_matches: "मैच की सूची देखें",
    now_public: "अब खोलो",
    now_private: "अप्रकाशित",
    check: "पुष्टि करें",
    edit2: "सम्पादन के लिए",
    news_detail: "समाचार विवरण",
    prefectures: "प्रीफेक्चर",

    hokkaido: "होक्काइडो",
    aomori: "आओमोरी",
    iwate: "इवाटे",
    miyagi: "मियागी",
    akita: "अकीता",
    yamagata: "यमगता",
    fukushima: "फुकुशिमा",
    ibaraki: "इबाराकी",
    tochigi: "तोचिगी",
    gunma: "गुनमा",
    saitama: "सीतामा",
    chiba: "चिबा",
    tokyo: "टोक्यो",
    kanagawa: "कानागावा",
    niigata: "निगाटा",
    toyama: "&quot;तोयामा&quot;",
    ishikawa: "इशिकावा",
    fukui: "फुकुई",
    yamanashi: "यमनाशी",
    nagano: "नागानो",
    gifu: "गिफू",
    shizuoka: "शिज़ुओका",
    aichi: "आइची",
    mie: "ट्रिपल",
    shiga: "शिगा",
    kyoto: "क्योटो",
    osaka: "ओसाका",
    hyogo: "ह्योगो",
    nara: "नारा",
    wakayama: "वाकायामा",
    tottori: "तोतोरी",
    shimane: "शिमाने",
    okayama: "ओकायामा",
    hiroshima: "हिरोशिमा",
    yamaguti: "यामागुची",
    tokushima: "तोकुशिमा",
    kagawa: "कागावा",
    echime: "एहिम",
    kochi: "कोच्चि",
    fukuoka: "फुकुओका",
    saga: "सागा",
    nagasaki: "&quot;नागासाकी&quot;",
    kumamoto: "कुमामोटो",
    oita: "ओइता",
    miyazaki: "मियाज़ाकी",
    kagoshima: "कागोशिमा",
    okinawa: "ओकिनावा",
    sinhalese: "सिंहल",
    exam_region: "प्रीफेक्चर",
    exam_place_list: "स्थलों की सूची",
    exam_place_name: "परीक्षा स्थल का नाम",
    care_evaluation_test: "दीर्घकालिक देखभाल कौशल प्रशिक्षण मूल्यांकन परीक्षा",
    clean_building_test: "भवन सफाई उद्योग अतीत की समस्याएं",
    answer: "जवाब",
    skill_test_measurement: "कौशल मापन परीक्षण",
    exam_problem: "परीक्षा का प्रश्न",
    fields: "खेत और सब्जियां",
    gardening: "सुविधा बागवानी",
    mushroom: "मशरूम",
    fruit: "फलों का पेड़",
    dairy: "दुग्धालय",
    poultry: "मुर्गी पालन",
    pig: "सुअर की खेती",
    beginner: "शुरुआती",
    professional: "पेशेवर ग्रेड",
    advanced: "उन्नत",
    technical_training_test: "तकनीकी प्रशिक्षु प्रशिक्षण मूल्यांकन परीक्षा",
    exam_part: "परीक्षा प्रश्नों का हिस्सा",
    tokoha_fruit: "तोकोहा फ्रूट ट्री",
    deciduous_fruit: "पर्णपाती फल वृक्ष",
    ver: "संस्करण",
    errata: "इरेटा",
    form_work: "फॉर्मवर्क निर्माण",
    construction: "पलस्तर",
    tunnel_line: "सुरंग प्रणोदन रेखा",
    earth_work: "धरती",
    loofing: "छत",
    elecommunication: "दूरसंचार",
    reinforcing_contstruction: "बार निर्माण को मजबूत करना",
    reinforcing_joint: "बार जोड़ को मजबूत करना",
    wall_painting: "पेंटिंग (दीवार को ढंकना)",
    board_finish: "बोर्ड फिनिश, इंटीरियर फिनिश",
    steeplejack: "तोबी",
    spray_insulation: "छिड़काव urethane इन्सुलेशन",
    marine_civil: "समुद्री सिविल इंजीनियरिंग",
    concrete_pumping: "कंक्रीट पम्पिंग",
    construction_machinery: "निर्माण मशीनरी निर्माण",
    learning_text: "लर्निंग टेक्स्ट",

    basic_aircraft: "बुनियादी विमान प्रौद्योगिकी का निष्कर्ष, विद्युत माप",
    worksafety_quality: "कार्य सुरक्षा, गुणवत्ता",
    aircraft_overview: "विमान अवलोकन",
    fish_general: "सामान्य रूप से मत्स्य पालन",
    fish_safety: "मत्स्य सुरक्षा",
    network_relations: "मत्स्य पालन विशिष्ट वर्ग",
    fish_relations: "मत्स्य पालन विशेषता मत्स्य पालन संबंधित",
    aquaculture_general: "सामान्य रूप से जलीय कृषि",
    feeding_aquaculture: "एक्वाकल्चर स्पेशलिटी फीडिंग एंड एक्वाकल्चर संबंधी",
    unfed_aquaculture: "एक्वाकल्चर स्पेशलिटी अनफेड एक्वाकल्चर-संबंधित",
    attachment: "अटैचमेंट्स",
    glossary: "शब्दावली",
    feneral_customer: "सामान्य ग्राहक सेवा",
    food_dring_cooking: "खाना बनाना और पीना",
    hygiene_management: "स्वच्छता प्रबंधन",
    visa_application: "विशिष्ट कौशल वीजा के लिए आवेदन",
    certificate_residence_tax: "1. निवास कर का प्रमाण पत्र (पिछले वर्ष के लिए)",
    salary_income_withholding : "२. वेतन आय रोक पर्ची की प्रति",
    national_health_insured: "3. राष्ट्रीय स्वास्थ्य बीमा बीमित व्यक्ति के कार्ड की एक प्रति (यदि व्यक्ति नामांकित है)",
    national_health_payment: "4. राष्ट्रीय स्वास्थ्य बीमा प्रीमियम भुगतान प्रमाणपत्र",
    national_health_receipt: "5. राष्ट्रीय स्वास्थ्य बीमा प्रीमियम रसीद की प्रति",

    technical_intern_training2: "6. दस्तावेज प्रमाणित करते हैं कि तकनीकी प्रशिक्षु प्रशिक्षण संख्या 2 सफलतापूर्वक पूरा कर लिया गया है",
    need_the_following : "आपको निम्न में से एक की आवश्यकता है: ",
    pass_certificate_test_specialized : "・ कौशल मूल्यांकन परीक्षा (विशेष ग्रेड) के व्यावहारिक कौशल परीक्षण के पास प्रमाण पत्र की एक प्रति",
    technical_intern_training3: "कौशल परीक्षा (तीसरी कक्षा) के व्यावहारिक परीक्षण के पास प्रमाण पत्र की एक प्रति",
    evaluation_record_technical_intern: "・ यदि आप उपरोक्त परीक्षा उत्तीर्ण नहीं करते हैं, तो आपको तकनीकी प्रशिक्षु प्रशिक्षु के लिए मूल्यांकन रिकॉर्ड भरना होगा। ",
    cartificate_pass_basic_test: "7.6 के विकल्प के रूप में, आप जापान फाउंडेशन जापानी बेसिक टेस्ट के पास प्रमाण पत्र की एक प्रति या जापानी भाषा प्रवीणता परीक्षा (एन4) या उच्चतर के पास प्रमाण पत्र की एक प्रति जमा कर सकते हैं। ",
    change_permission_application: "8. परिवर्तन अनुमति आवेदन का फोटोग्राफ (ऊर्ध्वाधर 4 सेमी x क्षैतिज 3 सेमी)",
    resume_data_time_entry: "9. प्रविष्टि के समय डेटा फिर से शुरू करें",
    select_file: "फ़ाइलें चुनें",

    description_movie: "स्पष्टीकरण वीडियो",
    how_to_use_movie: "वीडियो का उपयोग कैसे करें",
    movie_news: "1. विशिष्ट कौशल वीजा के बारे में समाचार",
    movie_exam: "2. परीक्षण की तारीख तक शेष दिनों की संख्या",
    movie_predict_pass: "3. अनुमानित पास दर",
    movie_ave_study_test: "4. अपने स्वयं के अध्ययन का औसत अंक",
    movie_similar_exam: "5. इसी तरह के परीक्षा प्रश्न",
    movie_learning_text: "6. सीखने की पाठ्यपुस्तक (पाठ्यपुस्तक) डाउनलोड करें",
    movie_solved_exam: "7. समस्याएं जिन्हें मैंने अतीत में हल किया था",
    movie_pased_exam: "8. पिछली समस्याओं को देखने के बारे में जो वास्तव में सामने आईं",
    movie_resume_regist: "9. प्रवेश के समय पंजीकरण फिर से शुरू करें",
    movie_pass_document_regist: "10. प्रवीणता परीक्षा पास का पंजीकरण",
    movie_agency_service: "11. परीक्षा आवेदन एजेंसी सेवा",
    movie_consule_service: "12. परामर्श सेवा सीखना",
    description_movie_trans: "यदि आप जापानी के अलावा किसी अन्य भाषा में देखना चाहते हैं, तो गियर मार्क पर क्लिक करें, उपशीर्षक और स्वचालित अनुवाद पर क्लिक करें, अपनी मूल भाषा चुनें और फिर देखें।",



    "cultivated_agriculture_general": "सामान्य रूप से खेती की खेती",
    "livestock_agriculture": "पशुधन कृषि",
    "介護": "नर्सिंग",
    "ビルクリーニング": "भवन की सफाई",
    "建設": "निर्माण",
    "自動車整備": "कार का रखरखाव",
    "航空業": "उड्डयन उद्योग",
    "農業": "कृषि",
    "漁業": "मछली पकड़ने",
    "飲食料品製造業": "खाद्य और पेय निर्माण उद्योग",
    "外食業": "रेस्टोरेंट व्यवसाय",
    "型枠施工": "फॉर्मवर्क निर्माण",
    "左官": "लेपक",
    "コンクリート圧送": "कंक्रीट पम्पिंग",
    "トンネル推進工": "सुरंग प्रणोदन कार्य",
    "建設機械施工": "निर्माण मशीनरी निर्माण",
    "大工": "बढ़ई",
    "屋根ふき": "पाटन",
    "電気通信": "दूरसंचार",
    "鉄筋施工": "बार निर्माण को मजबूत करना",
    "鉄筋継手": "बार संयुक्त को मजबूत करना",
    "壁装（壁張り）": "दीवार को ढंकना (दीवार को ढंकना)",
    "ボード仕上げ、内装仕上げ": "बोर्ड खत्म, आंतरिक खत्म",
    "とび": "कूद",
    "吹き付けウレタン断熱": "छिड़काव फायरिंग इन्सुलेशन",
    "海洋土木工": "समुद्री सिविल इंजीनियरिंग",
    "航空機の基本技術 締結、電気計測": "विमान बुनियादी प्रौद्योगिकी निष्कर्ष, विद्युत माप",
    "作業安全、品質": "कार्य सुरक्षा, गुणवत्ता",
    "航空機概要": "विमान सिंहावलोकन",
    "耕種農業全般": "सामान्य रूप से खेती की खेती",
    "畜産農業": "पशुधन कृषि",
    "漁業一般": "सामान्य रूप से मछली पकड़ना",
    "漁業安全": "मत्स्य पालन सुरक्षा",
    "漁業専門 綱関係": "मत्स्य पालन विशेषता रस्सी संबंध",
    "漁業専門 釣り関係": "मछली पकड़ने से संबंधित मछली पकड़ने में विशिष्ट",
    "養殖業一般": "सामान्य तौर पर जलीय कृषि",
    "養殖業専門 給餌養殖関係": "एक्वाकल्चर विशेषता फीडिंग एक्वाकल्चर",
    "養殖業専門 無給餌養殖関係": "एक्वाकल्चर विशेषता अनफेड एक्वाकल्चर",
    "接客全般": "सामान्य ग्राहक सेवा",
    "飲食物調理": "खाना-पीना खाना बनाना",
    "衛生管理": "स्वच्छता प्रबंधन",
    "日本語版": "जापानी संस्करण",
    "英語版": "अंग्रेजी संस्करण",
    "クメール語版": "खमेर संस्करण",
    "インドネシア語版": "इंडोनेशियाई संस्करण",
    "インドネシア語・正誤表": "इन्डोनेशियाई इरेटा",
    "ネパール語版": "नेपाली संस्करण",
    "モンゴル語版": "मंगोलियाई संस्करण",
    "ビルマ語版": "बर्मी संस्करण",
    "ベトナム語版": "वियतनामी संस्करण",
    "タイ語版": "थाई संस्करण",
    "テキスト１": "पाठ 1",
    "テキスト２": "पाठ 2",
    "テキスト３": "पाठ 3",
    "テキスト４": "पाठ 4",
    "テキスト５": "पाठ 5",
    "ミャンマー(ビルマ)語版": "म्यांमार (बर्मी) भाषा संस्करण",
    "カンボジア(クメール)語版": "कंबोडिया (खमेर) भाषा संस्करण",
    "ミャンマー語版": "बर्मी संस्करण",
    "中国語版": "चीनी संस्करण",
    "付属資料": "अनुरक्ति",
    "用語集": "शब्दकोष",

    invitation_code: "आमंत्रण संकेत",
exam_calender: "परीक्षा कार्यक्रम कैलेंडर",
move_exam_detail: "क्या आप परीक्षा कार्यक्रम विवरण पृष्ठ पर जाना चाहेंगे?",
move: "चलती",
plece_select_language: "कृपया कोई भाषा चुनें",
select: "चुनते हैं",
midle_category: "पेशा",
select_industry_description: "शुरुआत में, AELU केवल 3 उद्योगों का चयन कर सकता है, इसलिए केवल उस उद्योग का चयन करें जिसके लिए आप काम करना चाहते हैं। यदि आप इससे खुश हैं, तो अगला दबाएं",
done_member_regist_description_2: "अब से, हम कई प्रमाणन परीक्षाओं की तैयारी करके विशिष्ट कौशल वीज़ा प्राप्त करने के लिए AELU का समर्थन करेंगे।",
done_member_regist_2: "सदस्य पंजीकरण पूरा हो गया है।",
is_exist_user: "समान ईमेल पते वाला एक उपयोगकर्ता पहले से मौजूद है।",
invitation_code_description: "(कृपया भेजने वाले संगठन या जापानी भाषा स्कूल से आमंत्रण कोड दर्ज करें, अन्यथा व्यय निपटान स्क्रीन दिखाई देगी, इसलिए इसे दर्ज करना न भूलें।)",
pleace_select_region: "कृपया मेजबान प्रान्त का चयन करें",
pleace_add_messenger: "सभी संपर्क फेसबुक मेसेंजर के माध्यम से भेजे जाएंगे, इसलिए उन्हें जोड़ना सुनिश्चित करें",
add_messenger_bot: "सूचनाएं प्राप्त करें",
visa_application_description: "विशिष्ट कौशल वीजा के लिए आवेदन करते समय आवश्यक दस्तावेज़ भंडारण स्थान",
check_agree: "कृपया सहमत हों",
sample_title: "यह एक डमी शीर्षक है। कृपया सेट करें",
sample_description: "यह एक डमी विवरण है। कृपया सेट करें। यह एक डमी विवरण है। कृपया सेट करें। यह एक डमी विवरण है। कृपया सेट करें। यह एक डमी विवरण है। कृपया सेट करें। यह एक डमी विवरण है। कृपया सेट करें। यह एक डमी विवरण है। कृपया सेट करें। यह एक डमी विवरण है। कृपया सेट करें।",
create_profile_error: "इनपुट में त्रुटि है। कृपया आइटम की जांच करें",
setting_confirm: "कृपया इनपुट सामग्री की पुष्टि करें और रजिस्टर करें",
exam_learning: "परीक्षा सीखना",
recommend_problem_solve: "इसी तरह के परीक्षा प्रश्न हल करें",
of: "का",
see_solved_problem: "उन समस्याओं का समाधान करें जिन्हें आपने पूर्व में हल किया है \ n",
past_exam_collection: "\ N परीक्षा के प्रश्न जो पहले आए थे",
any_application_registration: "विभिन्न आवेदन पंजीकरण",
mypage_visa_application: "विशिष्ट कौशल वीजा \ n आवेदन",
applyt_exam_and_agent: "परीक्षा आवेदन \ n प्रॉक्सी सेवा आवेदन",
myapge_regist_accept_certificate: "स्किल टेस्ट \ nपास का रजिस्ट्रेशन",
mypage_consultaion_service: "सीखना परामर्श \ n सेवा",
consult: "परामर्श",
of_exam_day: "परीक्षा की तारीख",
your_ave_score: "आपके \ n परीक्षण के लिए औसत स्कोर",
your_estimated_pass_rate: "आपकी \ n अनुमानित पास दर",
your_ave_score_fotter: "आपके परीक्षण के लिए औसत स्कोर",
your_estimated_pass_rate_fotter: "अनुमानित पास दर",
mypage_study_text: "सीखने की पाठ्यपुस्तक डाउनलोड करें \ n",
exam_schedule: "परीक्षा कार्यक्रम",
resident_caption_title: "निवास कार्ड या आईडी कार्ड अपलोड करने के बारे में",
resident_caption: "कृपया एक निवास कार्ड या आईडी कार्ड अपलोड करें जो लाल फ्रेम में जानकारी की पुष्टि कर सके। \ nकृपया एक वैध निवास कार्ड या आईडी कार्ड अपलोड करें जिसकी समय-सीमा समाप्त नहीं हुई है। \ nपीडीएफ या जेपीजी प्रारूप में रंगीन छवि अपलोड करें।",
password_caption_title: "पासवर्ड अपलोड करने के बारे में",
password_caption: "कृपया एक पासपोर्ट छवि अपलोड करें जो आपके नाम / फोटो / अद्वितीय संख्या / जन्म तिथि / राष्ट्रीयता / समाप्ति तिथि की पुष्टि करती है जैसा कि लाल फ्रेम में दिखाया गया है। \ nकृपया एक वैध पासपोर्ट अपलोड करें जिसकी समय-सीमा समाप्त नहीं हुई है। \ nपीडीएफ या जेपीजी प्रारूप में रंगीन छवि अपलोड करें।",
title_help: "मदद",
step3_title_help: "कृपया अपनी जानकारी सही दर्ज करें।",
lineid_input_help: "ओपन लाइन → होम → सेटिंग्स → प्रोफाइल → आईडी देखने के लिए स्क्रॉल करें। कृपया वह आईडी दर्ज करें। यदि आपने इसे नहीं बनाया है, तो कृपया इसे बनाएं और दर्ज करें।",
country_input_help: "कृपया अपनी राष्ट्रीयता के देश का चयन करें।",
area_input_help: "अपने क्षेत्र का देश चुनें जहां आप वर्तमान में रहते हैं।",
phone_input_help: "कृपया अपना फोन नंबर दर्ज करें।",
issuing_input_help: "कृपया उस क्षेत्र का चयन करें जहां आपकी आईडी जारी की गई थी।",
idtype_input_help: "कृपया एक आईडी प्रकार चुनें। कृपया चयनित व्यक्ति की एक सुंदर तस्वीर लें और उसे अपलोड करें। कृपया सीधे शूट करें ताकि कोई विकर्ण या कट बिंदु न हों।",
invitation_input_help: "यदि आपके पास आमंत्रण कोड है, तो उसे दर्ज करें।",
exam_menu_help: "ऐसे प्रश्न होंगे जो उन प्रश्नों के समान होंगे जो वास्तव में अतीत में पूछे गए थे। परीक्षा की तैयारी के लिए बार-बार पूछे गए प्रश्नों को हल करें।",
past_menu_help: "आपके सामने ऐसी समस्याएं आएंगी जिनका समाधान आपने पूर्व में किया है। आइए गलतियों की समीक्षा करें।",
pastexam_menu_help: "यह उन परीक्षा प्रश्नों का पाठ है जो वास्तव में अतीत में मौजूद थे।",
text_menu_help: "आप महत्वपूर्ण बिंदुओं का अध्ययन करने के लिए अध्ययन पाठ्यपुस्तकों को देख सकते हैं और पता लगा सकते हैं कि आपको क्या समझ में नहीं आता है।",
visa_menu_help: "हम आपको एक विशिष्ट कौशल वीजा प्राप्त करने में मदद करेंगे। यदि आप किसी विशिष्ट कौशल के लिए वीजा प्राप्त करना चाहते हैं, तो कृपया यहां आवेदन करें।",
agency_menu_help: "हम आपकी ओर से विशिष्ट प्रवीणता परीक्षा के लिए आवेदन करेंगे। यदि आप एक विशिष्ट कौशल परीक्षा देना चाहते हैं, तो कृपया यहां आवेदन करें।",
cer_menu_help: "यदि आपने विशिष्ट प्रवीणता परीक्षा दी है और पास प्रमाणपत्र है, तो कृपया यहां पंजीकरण करें।",
service_menu_help: "यदि आपके कोई प्रश्न या चिंताएँ हैं, तो कृपया यहाँ चैट के माध्यम से हमसे संपर्क करें।",
occu_title_help: "कृपया 3 वांछित व्यवसायों का चयन करें।",
back: "वापसी",
before: "पिछली समस्या के लिए",
srilank: "श्रीलंका",
reselect: "यदि आप फ़ाइल बदलना चाहते हैं, तो &quot;अपना पासपोर्ट अपलोड करें&quot; को फिर से दबाएं और फिर से चुनें",
iphone_file: "iPhone के लिए, कृपया HEIC फ़ाइल से JPG फ़ाइल में कनवर्ट करने के बाद उपयोग करें।",
file_transmit: "फ़ाइलों को परिवर्तित करना",
combodia: 'combodia',
}
